<template>
  <div>
    <HeroSection />
    <WhatIsCepa />
    <WhoWillTake />
    <HowToTake />
  </div>
</template>

<script>
import HeroSection from '../components/HeroSection.vue'
import WhatIsCepa from '../components/WhatIsCepa.vue'
import WhoWillTake from '../components/WhoWillTake.vue'
import HowToTake from '../components/HowToTake.vue'

export default {
  name: 'HomePage',
  components: { HeroSection, WhatIsCepa, WhoWillTake, HowToTake }
}
</script>
